import { Link } from "@mui/material";

import AppIcon from "assets/images/about-us/JJ-App-icon.svg";
import GooglePlay from "assets/images/about-us/google-play-badge.svg";
import AppStore from "assets/images/about-us/app-store-badge.svg";
import { externalRoutes } from "routes";

import { Root, Title, Subtitle, Text, Icon, StoresContainer, Image } from "./styles";

const Apps = () => {
  return (
    <Root align="center">
      <Title variant="h1">Plus… we’ve got Apps!</Title>
      <Text>
        In addition to having a mobile-friendly website, we also have two 5-star apps! Both have been honored with an
        “App of the Day” feature! Try for yourself.
      </Text>
      <Icon src={AppIcon} alt="JibJab app icon" />
      <Subtitle variant="large">JibJab, The App</Subtitle>
      <Text>
        Available on both the App Store and PlayStore, this easy-to-use app has our entire Ecard library, videos galore
        – plus free GIFs! With all the ease and fun you can expect from JibJab.
      </Text>
      <StoresContainer>
        <Link href={externalRoutes.jjAppStore()} target="_blank" rel="noreferrer">
          <Image src={AppStore} alt="Download on the App Store" loading="lazy" />
        </Link>
        <Link href={externalRoutes.jjGooglePlay()} target="_blank" rel="noreferrer">
          <Image src={GooglePlay} alt="Get it on Google Play" loading="lazy" />
        </Link>
      </StoresContainer>
    </Root>
  );
};

export default Apps;
